/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyOptionGroup from './survey-option-group';
import SurveyOptionGroupDetail from './survey-option-group-detail';
import SurveyOptionGroupUpdate from './survey-option-group-update';
import SurveyOptionGroupDeleteDialog from './survey-option-group-delete-dialog';

const SurveyOptionGroupRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyOptionGroup />} />
    <Route path="new" element={<SurveyOptionGroupUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyOptionGroupDetail />} />
      <Route path="edit" element={<SurveyOptionGroupUpdate />} />
      <Route path="delete" element={<SurveyOptionGroupDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyOptionGroupRoutes;
